const translations = {
    en: {
        PREPARING: 'PREPARING',
        READY: 'READY',
        NO_ADDITIONAL_RESOURCES: 'no additional videos or images found.',
        CUSTOMER_ID: 'Customer ID',
        WAIT_TIME: 'Wait Time',
        MINUTES: 'min',
        LOADING: 'Loading',
        DOWNLOAD_APP_TEXT: "Skip the lines and earn rewards when you order & pay through the '{app}' app",
        DOWNLOAD_APP_TEXT_GENERIC: 'Skip the lines and earn rewards when you order & pay through the app'
    },
    fr: {
        PREPARING: 'EN PRÉPARATION',
        READY: 'PRÊT',
        NO_ADDITIONAL_RESOURCES: "aucune vidéo ou image supplémentaire trouvée.",
        CUSTOMER_ID: 'ID Client',
        WAIT_TIME: "Temps d'attente",
        MINUTES: 'min',
        LOADING: 'Chargement',
        DOWNLOAD_APP_TEXT: "Évitez les files d'attente et gagnez des récompenses lorsque vous commandez et payez via l'application '{app}'",
        DOWNLOAD_APP_TEXT_GENERIC: "Évitez les files d'attente et gagnez des récompenses lorsque vous commandez et payez via l'application"
    },
    es: {
        PREPARING: 'PREPARANDO',
        READY: 'LISTO',
        NO_ADDITIONAL_RESOURCES: 'no se encontraron videos o imágenes adicionales.',
        CUSTOMER_ID: 'ID de cliente',
        WAIT_TIME: 'Tiempo de espera',
        MINUTES: 'min',
        LOADING: 'Cargando',
        DOWNLOAD_APP_TEXT: "Evita las filas y gana recompensas cuando ordenas y pagas a través de la aplicación '{app}'",
        DOWNLOAD_APP_TEXT_GENERIC: 'Evita las filas y gana recompensas cuando ordenas y pagas a través de la aplicación'
    },
    de: {
        PREPARING: 'VORBEREITEN',
        READY: 'BEREIT',
        NO_ADDITIONAL_RESOURCES: 'keine zusätzlichen Videos oder Bilder gefunden.',
        CUSTOMER_ID: 'Kunden-ID',
        WAIT_TIME: 'Wartezeit',
        MINUTES: 'Min.',
        LOADING: 'Laden',
        DOWNLOAD_APP_TEXT: "Überspringe die Schlangen und sammle Prämien, wenn du über die App '{app}' bestellst und bezahlst",
        DOWNLOAD_APP_TEXT_GENERIC: 'Überspringe die Schlangen und sammle Prämien, wenn du über die App bestellst und bezahlst'
    },
    sv: {
        PREPARING: 'FÖRBEREDER',
        READY: 'KLAR',
        NO_ADDITIONAL_RESOURCES: 'inga ytterligare videor eller bilder hittades.',
        CUSTOMER_ID: 'Kund-ID',
        WAIT_TIME: 'Väntetid',
        MINUTES: 'min',
        LOADING: 'Laddar',
        DOWNLOAD_APP_TEXT: "Hoppa över köerna och tjäna belöningar när du beställer och betalar via appen '{app}'",
        DOWNLOAD_APP_TEXT_GENERIC: 'Hoppa över köerna och tjäna belöningar när du beställer och betalar via appen'
    },
};

export const translate = (key, language = 'en') => {
    const lang = translations[language] ? language : 'en';
    return translations[lang][key] || key;
};

export default translate;

